import { useLocation, useNavigate } from "react-router-dom";
import ChevronLeftIcon from "@assets/svg/ChevronLeftIcon";
import { useEffect, useRef, useState } from "react";
import {
  getContactMatchesJobs,
  getFiltterMatchesJobs,
} from "@endpoints/recruiter.service";
import { enqueueSnackbar } from "notistack";
import { MatchedJobStatus } from "@utils/constants";
import LoadingAnimation from "@assets/svg/LoadingAnimation";
import { colors } from "@nextui-org/theme";
import dayjs from "dayjs";

const NetworkDetailPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const member = location?.state?.member || location?.state;
  const id = member?.candidateId;
  const [activeTab, setActiveTab] = useState("Not viewed");
  const [matchesJonList, setMatchesJonList] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [tabCounts, setTabCounts] = useState({
    totalViewedByCandidate: 0,
    totalUnViewedByCandidate: 0,
    totalAppliedjobs: 0,
    totalInterviews: 0,
    totalSuccessFull: 0,
  });

  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [hasMore, setHasMore] = useState(true);
  const scrollRef = useRef();

  const getMatchesJobs = async (currentPage = 1) => {
    try {
      const { data } = await getContactMatchesJobs(id, currentPage, limit);
      setMatchesJonList((prev) =>
        currentPage === 1 ? data : [...prev, ...data]
      );
      if (currentPage === 1 && data.length > 0) {
        const first = data[0];
        setTabCounts({
          totalViewedByCandidate: first.totalViewedByCandidate,
          totalUnViewedByCandidate: first.totalUnViewedByCandidate,
          totalAppliedjobs: first.totalAppliedjobs,
          totalInterviews: first.totalInterviews,
          totalSuccessFull: first.totalSuccessFull,
        });
      }

      setHasMore(data.length === limit);
      // setMatchesJonList(data);
    } catch (error) {
      enqueueSnackbar("Oops! Something went wrong!", { variant: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  const FiltterMatchesJobs = async (filterStatus, currentPage = 1) => {
    try {
      const { data } = await getFiltterMatchesJobs(
        filterStatus,
        id,
        currentPage,
        limit
      );
      setMatchesJonList((prev) =>
        currentPage === 1 ? data : [...prev, ...data]
      );
      setHasMore(data.length === limit);
      // setMatchesJonList(data);
    } catch (error) {
      enqueueSnackbar("Oops! Something went wrong!", { variant: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const container = scrollRef.current;
      if (!container || isLoading || !hasMore) return;

      const threshold = 50;
      const isAtBottom =
        container.scrollHeight - container.scrollTop <=
        container.clientHeight + threshold;

      if (isAtBottom) {
        const nextPage = page + 1;
        setPage(nextPage);
        if (["Applied", "Interviewing", "Successful"].includes(activeTab)) {
          FiltterMatchesJobs(MatchedJobStatus[activeTab], nextPage);
        } else {
          getMatchesJobs(nextPage);
        }
      }
    };

    const container = scrollRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [page, isLoading, hasMore, activeTab]);

  useEffect(() => {
    setPage(1);
    setIsLoading(true);
    if (
      activeTab === "Applied" ||
      activeTab === "Interviewing" ||
      activeTab === "Successful"
    ) {
      FiltterMatchesJobs(MatchedJobStatus[activeTab], 1);
    } else {
      if (activeTab === "Not viewed" || activeTab === "Viewed") {
        getMatchesJobs(1);
      }
    }
  }, [activeTab]);
  useEffect(() => {
    getMatchesJobs(1);
  }, []);

  const filteredList = matchesJonList?.filter((data) => {
    if (["Applied", "Interviewing", "Successful"].includes(activeTab)) {
      return true;
    }

    if (activeTab === "Not viewed") return data?.viewedByCandidate === false;
    if (activeTab === "Viewed") return data?.viewedByCandidate === true;

    return true;
  });

  const handleItemClick = (jobData) => {
    // navigate("/job-application-detail", { state: { member, jobData } });
    navigate(`/network/${id}/${id}`, { state: { member, jobData } });
  };

  return (
    <div className="flex flex-col rounded-lg bg-white w-full flex-grow px-6 py-2 overflow-hidden">
      <button
        onClick={() => navigate("/network", { state: member })}
        className="flex items-center self-start my-3"
      >
        <ChevronLeftIcon className={"w-4 h-4"} fill="#4d4d4d" />
        <label className="text-xs font-medium text-primary cursor-pointer">
          Back to listing
        </label>
      </button>

      <div className="flex items-center bg-[#F1F5F9] my-3 rounded-md pl-16 py-2">
        <div className="flex w-full items-center">
          <div className="flex w-[40%] items-center gap-20">
            <div className="flex items-center gap-5">
              {member?.profilePic ? (
                <img
                  src={member?.profilePic}
                  className="rounded-full w-14 h-14 object-fill z-10 max-md:h-36 max-md:w-36"
                />
              ) : (
                <div className="font-montserrat text-white font-semibold uppercase w-14 h-14 rounded-full bg-gray-200 flex items-center justify-center text-xl">
                  {member?.firstName?.charAt(0).toUpperCase()}
                  {member?.lastName?.charAt(0).toUpperCase()}
                </div>
              )}

              <div className="text-primary space-y-2 text-xs">
                <p className="font-bold">
                  {member?.firstName} {member?.lastName}
                </p>
              </div>
            </div>
          </div>

          <div className="text-[#6f6f6f] space-y-2 text-xs">
            <p className="font-semibold px-8">{member?.jobTitle ?? "N/A"}</p>
          </div>

          <span className=" text-[#6f6f6f] font-medium text-xs py-1.5  h-max ">
            {member?.refNo ?? "N/A"}
          </span>
        </div>
      </div>

      <div className="">
        <div className="flex border-b gap-6 px-6 text-sm font-medium text-gray-700 ">
          <div className="flex gap-6">
            <p className="text-xs flex font-semibold text-primary items-center">
              Filters :
            </p>

            <button
              className={`text-xs px-4 py-2 mb-1 ${
                activeTab === "Not viewed"
                  ? "font-medium  border rounded-sm border-[#F2F2F2] bg-[#DDDDDD] text-primary"
                  : "text-gray-500 border border-transparent"
              }`}
              onClick={() => setActiveTab("Not viewed")}
            >
              Not viewed
              <span className="text-[#00AAFF] pl-1">
                ({tabCounts.totalUnViewedByCandidate})
              </span>
            </button>

            <button
              className={`text-xs px-4 py-2 mb-1 ${
                activeTab === "Viewed"
                  ? "font-medium border rounded-sm  border-[#F2F2F2] bg-[#DDDDDD] text-primary"
                  : "text-gray-500 border border-transparent"
              }`}
              onClick={() => setActiveTab("Viewed")}
            >
              Viewed
              <span className="text-[#00AAFF] pl-1">
                {" "}
                ({tabCounts.totalViewedByCandidate})
              </span>
            </button>

            <button
              className={`text-xs px-4 py-2 mb-1 ${
                activeTab === "Applied"
                  ? "font-medium  border  border-[#F2F2F2] bg-[#DDDDDD] text-primary"
                  : "text-gray-500 border border-transparent"
              }`}
              onClick={() => setActiveTab("Applied")}
            >
              Applied
              <span className="text-[#00AAFF] pl-1">
                ({tabCounts.totalAppliedjobs})
              </span>
            </button>
            <button
              className={`text-xs px-4 py-2 mb-1 ${
                activeTab === "Interviewing"
                  ? "font-medium  border rounded-sm border-[#F2F2F2] bg-[#DDDDDD] text-primary"
                  : "text-gray-500 border border-transparent"
              }`}
              onClick={() => setActiveTab("Interviewing")}
            >
              Interviewing
              <span className="text-[#00AAFF] pl-1">
                ({tabCounts.totalInterviews})
              </span>
            </button>

            <button
              className={`text-xs px-4 py-2 mb-1 ${
                activeTab === "Successful"
                  ? "font-medium  border rounded-sm border-[#F2F2F2] bg-[#DDDDDD] text-primary"
                  : "text-gray-500 border border-transparent"
              }`}
              onClick={() => setActiveTab("Successful")}
            >
              Successful
              <span className="text-[#00AAFF] pl-1">
                ({tabCounts.totalSuccessFull})
              </span>
            </button>
          </div>
        </div>
      </div>
      <div
        className="overflow-y-scroll no-scrollbar mt-1 flex-1"
        ref={scrollRef}
      >
        {isLoading ? (
          <div className="flex items-center justify-center h-full py-20">
            <LoadingAnimation color={colors.black} className={"w-6 h-6"} />
          </div>
        ) : (
          <>
            <div className="overflow-y-scroll no-scrollbar">
              {filteredList?.length > 0 ? (
                <>
                  {filteredList.map((data, index) => (
                    <div
                      key={index}
                      className="grid grid-cols-[1fr,1fr,1fr,1fr,1fr,1fr] gap-4 items-center px-6 py-5 text-xs border-b text-gray-700 radius-[4px] border-gray-200 hover:bg-gray-50 cursor-pointer"
                      onClick={() => handleItemClick(data)}
                    >
                      <div className="font-bold text-gray-800">
                        {data?.jobTitle ?? "N/A"}
                      </div>

                      <div className="font-medium text-gray-800 text-center">
                        {data?.matchingPercentage != null
                          ? `${data.matchingPercentage}% match`
                          : "N/A"}
                      </div>

                      <div className="text-gray-500 italic">
                        {dayjs(data?.createdAt).format("h:mm DD MMMM YY")}
                      </div>

                      <div className="text-[#6F6F6F] text-center">
                        {data?.refNo ?? "N/A"}
                      </div>

                      <div
                        className={`w-28 py-2 text-primary text-center font-medium ${
                          activeTab === "Not viewed"
                            ? "border rounded bg-[#BABABA]"
                            : ""
                        }`}
                      >
                        {["Applied", "Interviewing", "Successful"].includes(
                          activeTab
                        )
                          ? activeTab
                          : data?.viewedByCandidate === false
                          ? "Not viewed"
                          : "Viewed"}
                      </div>

                      {!data?.viewedByCandidate === false && (
                        <div className="text-[#6F6F6F] font-normal text-center">
                          {dayjs(data?.updatedAt).format("h:mm DD MMMM YY") ??
                            "N/A"}
                        </div>
                      )}
                    </div>
                  ))}

                  {!isLoading && hasMore && (
                    <div className="flex justify-center py-4">
                      <LoadingAnimation
                        color={colors.black}
                        className="w-5 h-5"
                      />
                    </div>
                  )}
                </>
              ) : (
                <p className="text-sm text-center text-gray-500 mt-20">
                  No jobs found under{" "}
                  <span className="font-semibold">{activeTab}</span> tab.
                </p>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default NetworkDetailPage;

{
  /* 
      <div className="overflow-y-scroll no-scrollbar mt-1">
        <div className="overflow-y-scroll no-scrollbar">
          {filteredList?.length > 0 ? (
            filteredList.map((data, index) => {
              return (
                <div
                  key={index}
                  className="grid grid-cols-[1fr,1fr,1fr,1fr,1fr,1fr] gap-4 items-center px-6 py-5 text-xs border-b text-gray-700 radius-[4px] border-gray-200 hover:bg-gray-50 cursor-pointer"
                  onClick={() => handleItemClick(data)}
                >
                  <div className="font-bold text-gray-800">
                    {data?.jobTitle ?? "N/A"}
                  </div>

                  <div className="font-medium text-gray-800 text-center">
                    {data?.matchingPercentage != null
                      ? `${data.matchingPercentage}% match`
                      : "N/A"}
                  </div>

                  <div className="text-gray-500 italic">
                    {dayjs(data?.createdAt).format("h:mm DD MMMM YY")}
                  </div>

                  <div className="text-[#6F6F6F] text-center">
                    {data?.refNo ?? "N/A"}
                  </div>

                  <div
                    className={`w-28 py-2 text-primary text-center font-medium ${
                      activeTab === "Not viewed"
                        ? "border rounded bg-[#BABABA]"
                        : ""
                    }`}
                  >
                    {["Applied", "Interviewing", "Successful"].includes(
                      activeTab
                    )
                      ? activeTab
                      : data?.viewedByCandidate === false
                      ? "Not viewed"
                      : "Viewed"}
                  </div>
                   here t0
                  <div
                    className={`w-28 py-2 text-primary text-center font-medium ${
                      !data?.viewedByCandidate
                        ? "border rounded bg-[#BABABA]"
                        : ""
                    }`}
                  >
                    {data?.applied
                      ? "Applied"
                      : data?.interviewing
                      ? "Interviewing"
                      : data?.isSuccessFull
                      ? "Successful"
                      : data?.viewedByCandidate === false
                      ? "Not viewed"
                      : "Viewed"}
                  </div>

                  here too

                  {!data?.viewedByCandidate === false && (
                    <div className="text-[#6F6F6F] font-normal text-center">
                      {dayjs(data?.updatedAt).format("h:mm DD MMMM YY") ??
                        "N/A"}
                    </div>
                  )}
                </div>
              );
            })
          ) : (
            <p className="text-sm text-center text-gray-500 mt-20">
              No jobs found under{" "}
              <span className="font-semibold">{activeTab}</span> tab.
            </p>
          )}
        </div>
      </div> */
}
